export default {
  lucky: {
    prizeAgain: 'หมุนอีกครั้ง',
    prizeThanks: 'โชคดีครั้งหน้า',
    remainingChance: 'จำนวนครั้งที่เหลือ',
    task: 'ภารกิจ',
    deposit: 'ฝากเงิน',
    wager: 'เดิมพัน',
    noChance: 'No spins available',
    drawFailed: 'Draw failed, please try again',
    prizeWin: 'Congratulations! You won {amount}',
    prizeAgainMsg: 'You got a free spin!',
  },
  card: {
    title: 'สะสมการ์ด',
    puzzleRound: 'รอบ {current}/{total}',
    puzzleReward: 'รางวัลครบชุด {amount}',
    redeem: 'แลก',
    redeemSuccess: 'แลกสำเร็จ',
    redeemSuccessWithReward: 'แลกสำเร็จ! คุณได้รับ {amount} {currency}',
    redeemFailed: 'แลกไม่สำเร็จ',
    notComplete: 'ยังสะสมไม่ครบ ไม่สามารถแลกได้',
    drawFailed: 'จับฉลากไม่สำเร็จ โปรดลองใหม่',
    gainLetter: 'ยินดีด้วย! คุณได้รับตัวอักษร {letter}',
    gainBlock: 'ยินดีด้วย! คุณได้รับภาพ {blockNo}',
    letterReward: '{redeemed}/{limit} · reward {amount}',
  },
  treasureChest: {
    invite: 'เชิญ',
    claimReward: 'รับรางวัล',
    noChest: 'ไม่มีหีบสมบัติ',
    claimSuccess: 'รับหีบสมบัติ {count} ใบ, {amount} {currency}',
    modalTitle: 'หีบสมบัติ',
    modalSubtitle: 'ปัดเพื่อดูทั้งหมด',
    chipTodayClaimed: 'รับวันนี้',
    chipClaimable: 'รับได้',
    chipLocked: 'ล็อก',
    totalClaimedCount: 'จำนวนหีบที่รับแล้ว',
    totalClaimedAmount: 'ยอดรวมที่รับแล้ว',
    chestUnit: 'ใบ',
    claimAll: 'รับทั้งหมด',
    goInvite: 'ไปเชิญเพื่อน',
    claimSingleSuccess: 'รับ {amount} {currency} แล้ว',
    labelClaimed: 'รับแล้ว',
    labelClaimable: 'รับได้',
    labelLocked: 'ล็อก',
  },
}
